<style lang="less"></style>

<template>
    <MenuList :menuList="menuList" @handleClicks="handleClicks(...arguments)" />
</template>

<script lang="ts">
    declare var EDDocument: any;
    import { Component, Prop, Vue } from "vue-property-decorator";
    import MenuList from "@/app/components/MenuList.vue";

    @Component({
        components: {
            MenuList,
        },
    })
    export default class marginsMenus extends Vue {
        get menuList() {
            return {
                list: [{ label: this.$t("showMargins"), checked: this.isShowMargin }, { label: this.$t("marginSetting") }],
            };
        }
        handleClicks(...args) {
            let index = args[0];
            // index 为0或1，多于两种情况需优化条件语句
            if (index) {
                this.marginSetting();
            } else {
                this.showMargin();
            }
        }
        closeDrop() {
            this.$emit("closeDrop");
        }
        showMargin() {
            EDDocument._gcfg._showPageMargin = !EDDocument._gcfg._showPageMargin;
            if (EDDocument._gcfg._showPageMargin) {
                window["_view"]._activePage._margin.set(EDDocument._gcfg._pageMarginX, EDDocument._gcfg._pageMarginY);
            } else {
                window["_view"]._activePage._margin.reset();
            }
            window["_view"].drawBackground();
            this.$store.commit("setPageStat", {
                type: "showMargin",
                data: EDDocument._gcfg._showPageMargin,
            });
            console.log(EDDocument._gcfg._showPageMargin);
            this.$track("menu", "view", "showPageMargin " + EDDocument._gcfg._showPageMargin);
            this.closeDrop();
        }
        marginSetting() {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: true,
            });
            this.$store.commit("setDialogState", {
                type: "dialogType",
                data: "Options",
            });
            this.$track("menu", "view", "marginSetting");
            this.closeDrop();
        }

        get isShowMargin() {
            return this.$store.state.page.showMargin;
        }

        mounted() {}

        created() {}
    }
</script>
<i18n>
{
  "zh": {
    "showMargins": "显示边界",
    "marginSetting": "边界设置"
  },
  "en": {
    "showMargins": "Show Margins",
    "marginSetting": "Margin Settings"
  },
  "fr": {
    "showMargins": "Afficher les Marges",
    "marginSetting": "Paramètres de marge"
  },
  "de": {
    "showMargins": "Seitenränder anzeigen",
    "marginSetting": "Seitenränder einstellen"
  },
  "jp": {
    "showMargins": "余白を表示",
    "marginSetting": "余白設定"
  },
  "es": {
    "showMargins": "Mostrar los márgenes",
    "marginSetting": "Ajustes del margen"
  },
  "pt": {
    "showMargins": "Mostrar Limites",
    "marginSetting": "Configurações de Limite"
  },
  "it": {
    "showMargins": "Mostra Margini",
    "marginSetting": "Impostazioni Margini"
  },
  "tw": {
    "showMargins": "顯示邊界",
    "marginSetting": "邊界設置"
  }
}
</i18n>
